import { connect } from 'react-redux';
import { updateSurveys } from '../../actions';
import ASQFilter from '../../components/filters/ASQFilter';
import { enqueueAsqCSVReport } from '../../actions/asq';
import { enqueueFollowUpCSVReport } from '../../actions/followup';
import { getCohorts, getSubgroups, getLoaders, getPlayersIndexedOptions } from '../../selectors';
import { showReportDetailsModal } from '../../actions/internal';
import { loadPlayersFilters, loadPlayersFiltersByIds } from '../../actions';
import _ from 'lodash';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    cohorts: getCohorts(state),
    subgroups: getSubgroups(state),
    groups: state.filters.groups,
    meta: state.meta.surveys,
    players: state.filters.players,
    filterOptions: getPlayersIndexedOptions(state.filters),
    teachers: state.filters.teachers,
    csvReport: state.asqSurveysCSVReport,
    followUpCsvReport: state.followUpSurveysCSVReport,
    withScope: state.filters.withScope,
    isLoading: getLoaders(state, ['SURVEYS_FILTER', 'SURVEYS']),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFinishedAtChange: (finishedAtStart, finishedAtEnd) => {
      dispatch(updateSurveys({ finishedAtStart, finishedAtEnd, page: 1 }))
    },
    onAsqTypeChange: (asq) => {
      dispatch(updateSurveys({ asq, page: 1 }))
    },
    onCohortChange: (cohorts) => {
      dispatch(updateSurveys({ cohorts, page: 1 }));
    },
    onGroupChange: (groups) => {
      dispatch(updateSurveys({ groups, page: 1 }))
    },
    onSubgroupChange: (subgroups) => {
      dispatch(updateSurveys({ subgroups, page: 1 }))
    },
    onPlayerChange: (selectedOption) => {
      const value = selectedOption && selectedOption.value;
      dispatch(updateSurveys({ player: value, page: 1 }))
    },
    onPlayerFilter: (search) => {
      dispatch(loadPlayersFilters(search, 'app'));
    },
    onPlayerFilterById: (ids) => {
      dispatch(loadPlayersFiltersByIds(ids, 'app'));
    },
    onRecentChange: (value) => {
      dispatch(updateSurveys({ recent: value, page: 1 }))
    },
    onWithConcernOnlyChange: (value) => {
      dispatch(updateSurveys({ concern: value, page: 1 }))
    },
    onWithMonitorOrReferChange: (value) => {
      dispatch(updateSurveys({ monitorOrRefer: value, page: 1 }))
    },
    onFollowUpSelectChange: (followUpSelect) => {
      dispatch(updateSurveys({ followUpSelect, page: 1 }))
    },
    onCSVEnqueue: _.debounce((asq) => {
      dispatch(enqueueAsqCSVReport({ asq: asq }));
    }, 500),
    onFollowUpCSVEnqueue: _.debounce((asq) => {
      dispatch(enqueueFollowUpCSVReport({ asq: asq }));
    }, 500),
    onReportDetailsShow: (modal) => (report) => {
      dispatch(showReportDetailsModal(report, modal));
    },
  }
}

const ASQFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ASQFilter)

export default ASQFilterContainer;
